<script lang="ts">
  import { Link, page } from "@inertiajs/svelte"
  import {
    ClipboardList,
    DollarSign,
    History,
    LayoutGrid,
    ListTodo,
    Users,
  } from "@lucide/svelte"

  import NavMain from "@/components/nav-main.svelte"
  import NavUser from "@/components/nav-user.svelte"
  import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
  } from "@/components/ui/sidebar"
  import {
    adminIndexTaskInstancesPath,
    dashboardPath,
    paymentsPath,
    taskTemplatesPath,
    userDashboardPath,
    userDashboardTaskHistoryPath,
    usersPath,
  } from "@/routes"
  import { type NavItem } from "@/types"

  import AppLogo from "./app-logo.svelte"

  const auth = $derived($page.props.auth)
  const isAdmin = $derived(auth?.user?.role === "admin")
  const dashboardHref = $derived(
    isAdmin ? dashboardPath() : userDashboardPath(),
  )

  const mainNavItems = $derived<NavItem[]>([
    {
      title: "Dashboard",
      href: dashboardHref,
      icon: LayoutGrid,
    },
    ...(isAdmin
      ? [
          {
            title: "Task Templates",
            href: taskTemplatesPath(),
            icon: ListTodo,
          },
          {
            title: "Task Instances",
            href: adminIndexTaskInstancesPath(),
            icon: ClipboardList,
          },
          {
            title: "Payments",
            href: paymentsPath(),
            icon: DollarSign,
          },
          {
            title: "Users",
            href: usersPath(),
            icon: Users,
          },
        ]
      : [
          {
            title: "Task History",
            href: userDashboardTaskHistoryPath(),
            icon: History,
          },
        ]),
  ])
</script>

<Sidebar collapsible="icon" variant="inset">
  <SidebarHeader>
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg">
          {#snippet child({ props })}
            <Link {...props} href={dashboardHref}>
              <AppLogo />
            </Link>
          {/snippet}
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  </SidebarHeader>

  <SidebarContent>
    <NavMain items={mainNavItems} />
  </SidebarContent>

  <SidebarFooter>
    <NavUser />
  </SidebarFooter>
</Sidebar>
